"use client"

import NextError from "next/error"

// Render the default Next.js 404 page when a route
// is requested that doesn't match the proxy and
// therefore doesn't have a locale associated with it.

export default function NotFound() {
  return (
    <html lang="en">
      <body>
        <NextError statusCode={404} />
      </body>
    </html>
  )
}
